import React from "react";

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const Component = props => {

  const handleAction = () => { props.handleAction(props.params); }

  return (
    <Dialog
      open={props.isOpen}
      fullWidth={true}
      maxWidth="xs"  
      aria-labelledby="Confirmar"
      aria-describedby="Dialogo de confirmación para validar un registro."
    >
      <DialogTitle disableTypography={true}>¿Estás seguro que deseas continuar?</DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleAction} color="primary" autoFocus>
          Si, estoy seguro.
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Component;